const SvgArsEmptyReport = (props) => (
  <svg
    width={200}
    height={141}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1414_10647)">
      <path
        d="M91.6211 125C126.114 125 154.076 97.0178 154.076 62.5C154.076 27.9822 126.114 0 91.6211 0C57.1281 0 29.166 27.9822 29.166 62.5C29.166 97.0178 57.1281 125 91.6211 125Z"
        fill="#EAEEF9"
      />
      <g filter="url(#filter0_d_1414_10647)">
        <path
          d="M117.775 20.3486H81.2637C78.5022 20.3486 76.2637 22.5872 76.2637 25.3486V36.6664C76.2637 39.4279 78.5022 41.6664 81.2637 41.6664H117.775C120.537 41.6664 122.775 39.4279 122.775 36.6664V25.3486C122.775 22.5872 120.537 20.3486 117.775 20.3486Z"
          fill="url(#paint0_linear_1414_10647)"
        />
      </g>
      <path d="M77.3535 31.0078H122.048" stroke="#D6DCE8" strokeWidth={1.5} />
      <path d="M106.06 21.2012V40.271" stroke="#D6DCE8" strokeWidth={1.5} />
      <path
        d="M80.624 25.4648H98.0659"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M109.694 25.4648H114.054"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M80.624 35.6973H98.0659"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M109.694 35.6973H114.054"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <g filter="url(#filter1_d_1414_10647)">
        <path
          d="M63.5116 20.3486H27C24.2386 20.3486 22 22.5872 22 25.3486V102.558C22 105.319 24.2386 107.558 27 107.558H63.5116C66.273 107.558 68.5116 105.319 68.5116 102.558V25.3486C68.5116 22.5872 66.273 20.3486 63.5116 20.3486Z"
          fill="url(#paint1_linear_1414_10647)"
        />
      </g>
      <g filter="url(#filter2_d_1414_10647)">
        <path
          d="M117.775 51.3564H81.2637C78.5022 51.3564 76.2637 53.595 76.2637 56.3564V97.713C76.2637 100.474 78.5022 102.713 81.2637 102.713H117.775C120.537 102.713 122.775 100.474 122.775 97.713V56.3564C122.775 53.595 120.537 51.3564 117.775 51.3564Z"
          fill="url(#paint2_linear_1414_10647)"
        />
      </g>
      <g filter="url(#filter3_d_1414_10647)">
        <path
          d="M172.039 20.3486H135.527C132.766 20.3486 130.527 22.5872 130.527 25.3486V61.8602C130.527 64.6217 132.766 66.8602 135.527 66.8602H172.039C174.8 66.8602 177.039 64.6217 177.039 61.8602V25.3486C177.039 22.5872 174.8 20.3486 172.039 20.3486Z"
          fill="url(#paint3_linear_1414_10647)"
        />
      </g>
      <path
        d="M28.7827 39.7285H62.2129"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M28.7827 32.9453H62.2129"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M28.7827 46.5117H62.2129"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M135.372 29.0693H168.802"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M28.7827 53.2949H46.7091"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M135.372 35.8525H153.298"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M143.534 59.3829L140.378 59.4222C139.775 59.4763 139.36 58.9038 139.317 58.4199L139.273 51.1063C139.219 50.5013 139.789 50.0842 140.271 50.0409L143.427 50.0016C144.03 49.9475 144.446 50.52 144.489 51.0039L144.533 58.3175C144.587 58.9225 144.148 59.4497 143.534 59.3829Z"
        fill="#D6DCE8"
      />
      <path
        d="M151.556 59.3949L148.4 59.4343C147.797 59.4884 147.382 58.9159 147.338 58.432L147.354 47.6981C147.3 47.0932 147.87 46.6761 148.353 46.6328L151.509 46.5934C152.112 46.5393 152.527 47.1118 152.57 47.5958L152.555 58.3296C152.609 58.9346 152.038 59.3516 151.556 59.3949Z"
        fill="#D6DCE8"
      />
      <path
        d="M168.044 59.3949L164.888 59.4343C164.285 59.4884 163.869 58.9159 163.826 58.432L163.842 47.6981C163.788 47.0932 164.358 46.6761 164.84 46.6328L167.997 46.5934C168.599 46.5393 169.015 47.1118 169.058 47.5958L169.042 58.3296C169.096 58.9346 168.526 59.3516 168.044 59.3949Z"
        fill="#D6DCE8"
      />
      <path
        d="M159.446 59.2964L156.29 59.3358C155.687 59.3899 155.271 58.8174 155.228 58.3335L155.172 44.0692C155.118 43.4643 155.689 43.0472 156.171 43.0039L159.327 42.9645C159.93 42.9104 160.345 43.4829 160.389 43.9669L160.445 58.2311C160.498 58.8361 160.059 59.3633 159.446 59.2964Z"
        fill="#AAB2C5"
      />
      <path
        d="M44.4529 73.4612L44.3735 66.1826C52.4976 66.7448 58.8995 73.485 59.078 81.5316C59.1603 86.69 56.4608 91.2494 52.3393 93.8398L48.5972 87.2313C50.4243 85.9112 51.529 83.7569 51.5658 81.186C51.5374 77.3964 48.3365 74.0263 44.4529 73.4612Z"
        fill="#AAB2C5"
      />
      <path
        d="M42.7774 66.3672L42.856 73.5866C40.5099 73.7869 38.3936 75.0633 37.1575 77.0346L30.9402 72.9158C33.4012 69.1223 37.6337 66.5694 42.7774 66.3672Z"
        fill="#F1F3F9"
      />
      <path
        d="M29.6131 74.8281L35.9759 78.956C35.766 79.6834 35.5561 80.4108 35.6429 81.3199C35.6373 85.5183 39.2512 89.0531 43.7385 89.2318C44.9813 89.2144 46.0815 89.0318 47.0388 88.684L50.7479 95.0783C48.6569 96.0549 46.2915 96.5524 43.817 96.4384C35.2932 96.279 28.3621 89.3911 28.208 81.1267C28.222 78.8787 28.6978 76.68 29.6131 74.8281Z"
        fill="#D6DCE8"
      />
      <path
        d="M82.8706 63.8461L91.908 72.8183L102.021 62.6259L113.712 60.9033"
        stroke="#AAB2C5"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M83.0861 66.7118C84.6294 66.7118 85.8792 65.46 85.8792 63.9174C85.8792 62.3748 84.6294 61.123 83.0861 61.123C81.5428 61.123 80.293 62.3748 80.293 63.9174C80.293 65.46 81.5428 66.7118 83.0861 66.7118Z"
        fill="white"
        stroke="#AAB2C5"
        strokeWidth={2}
      />
      <path
        d="M91.9801 75.6122C93.5234 75.6122 94.7733 74.3604 94.7733 72.8178C94.7733 71.2751 93.5234 70.0234 91.9801 70.0234C90.4369 70.0234 89.187 71.2751 89.187 72.8178C89.187 74.3604 90.4369 75.6122 91.9801 75.6122Z"
        fill="white"
        stroke="#AAB2C5"
        strokeWidth={2}
      />
      <path
        d="M102.237 65.42C103.78 65.42 105.03 64.1682 105.03 62.6255C105.03 61.0829 103.78 59.8311 102.237 59.8311C100.694 59.8311 99.4438 61.0829 99.4438 62.6255C99.4438 64.1682 100.694 65.42 102.237 65.42Z"
        fill="white"
        stroke="#AAB2C5"
        strokeWidth={2}
      />
      <path
        d="M113.713 63.6973C115.256 63.6973 116.506 62.4455 116.506 60.9028C116.506 59.3602 115.256 58.1084 113.713 58.1084C112.169 58.1084 110.919 59.3602 110.919 60.9028C110.919 62.4455 112.169 63.6973 113.713 63.6973Z"
        fill="white"
        stroke="#AAB2C5"
        strokeWidth={2}
      />
      <path
        d="M83.5312 81.3955V96.8955"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M83.5312 86.3955V93.3955"
        stroke="#AAB2C5"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M91.5312 81.3955V96.8955"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M91.5312 83.3955V85.3955"
        stroke="#AAB2C5"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M99.5312 81.3955V96.8955"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M99.5312 84.3955V89.3955"
        stroke="#AAB2C5"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M107.531 81.3955V96.8955"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M107.531 84.3955V94.3955"
        stroke="#AAB2C5"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M115.531 81.3955V96.8955"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M115.531 86.3955V90.3955"
        stroke="#AAB2C5"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1414_10647"
        x={54.2637}
        y={9.34863}
        width={90.5117}
        height={65.3174}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1414_10647"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1414_10647"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_1414_10647"
        x={0}
        y={9.34863}
        width={90.5117}
        height={131.209}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1414_10647"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1414_10647"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_1414_10647"
        x={54.2637}
        y={40.3564}
        width={90.5117}
        height={95.3564}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1414_10647"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1414_10647"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_1414_10647"
        x={108.527}
        y={9.34863}
        width={90.5117}
        height={90.5117}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1414_10647"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1414_10647"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1414_10647"
        x1={99.5043}
        y1={19.8555}
        x2={99.5043}
        y2={41.8963}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1414_10647"
        x1={45.2407}
        y1={18.3314}
        x2={45.2407}
        y2={108.498}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1414_10647"
        x1={99.5043}
        y1={50.1685}
        x2={99.5043}
        y2={103.267}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1414_10647"
        x1={153.768}
        y1={19.2728}
        x2={153.768}
        y2={67.3617}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <clipPath id="clip0_1414_10647">
        <rect width={200} height={141} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgArsEmptyReport;
